import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import { BookingProvider } from "./components/Booking";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import ProgramDetail from "./pages/ProgramDetail";
import Schedule from "./pages/Schedule";
import Pricing from "./pages/Pricing";
import Stories from "./pages/Stories";
import Events from "./pages/Events";
import WhatIsHyrox from "./pages/WhatIsHyrox";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <BookingProvider>
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/programs" element={<Programs />} />
                <Route path="/programs/:slug" element={<ProgramDetail />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/success-stories" element={<Stories />} />
                <Route path="/events" element={<Events />} />
                <Route path="/what-is-hyrox" element={<WhatIsHyrox />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-center" theme="dark" richColors />
          </BookingProvider>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
